export default __webpack_public_path__ + "assets/images/buildings-and-land_1VamY.jpg";